/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Stat_DistanceInputs */

const en_us2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const pt_br2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distância`)
};

const es_419_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia`)
};

const pt_pt2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distância`)
};

const fr_fr2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const de_de2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanz`)
};

const it_it2_workout_after_stat_distance = /** @type {(inputs: Workout_After_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza`)
};

/**
* | output |
* | --- |
* | "Distance" |
*
* @param {Workout_After_Stat_DistanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_stat_distance = /** @type {((inputs?: Workout_After_Stat_DistanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Stat_DistanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_stat_distance(inputs)
	if (locale === "es-419") return es_419_workout_after_stat_distance(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_stat_distance(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_stat_distance(inputs)
	if (locale === "de-DE") return de_de2_workout_after_stat_distance(inputs)
	if (locale === "it-IT") return it_it2_workout_after_stat_distance(inputs)
	return en_us2_workout_after_stat_distance(inputs)
});
export { workout_after_stat_distance as "workout-after.stat_distance" }